import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { safeLocalSignOut } from '@/lib/supabase'

// ── Global unhandled rejection handler ──────────────────────────────
// Catches async errors that bubble outside React's error boundary,
// most importantly Supabase auto-refresh failures (expired/invalid refresh token).
window.addEventListener('unhandledrejection', (event) => {
  const reason = event?.reason;

  // Check if it's a Supabase auth error
  const isAuthError =
    reason instanceof Error &&
    (reason.message?.includes('Invalid Refresh Token') ||
     reason.message?.includes('Refresh Token Not Found') ||
     reason.message?.includes('AuthApiError') ||
     reason.message?.includes('AuthSessionMissingError') ||
     reason?.name === 'AuthApiError' ||
     reason?.name === 'AuthSessionMissingError');

  if (isAuthError) {
    console.warn('[main] Unhandled auth rejection caught, signing out locally:', reason.message);
    // Prevent the error from crashing the page
    event.preventDefault();
    // Wipe local session without calling server (token is already invalid)
    safeLocalSignOut().finally(() => {
      // Force reload to /login
      window.location.href = '/login';
    });
  }
  // For non-auth errors, let the browser handle them normally (console error, etc.)
});

// Also listen for 'error' events on the window (some browsers fire this instead)
window.addEventListener('error', (event) => {
  const message = event?.message || '';
  if (
    message.includes('Invalid Refresh Token') ||
    message.includes('Refresh Token Not Found')
  ) {
    console.warn('[main] Global error caught auth failure, signing out:', message);
    event.preventDefault();
    safeLocalSignOut().finally(() => {
      window.location.href = '/login';
    });
  }
});

const splash = document.getElementById('splash');

const root = createRoot(document.getElementById('root')!)
root.render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// Hide splash once React has mounted (next microtask)
Promise.resolve().then(() => {
  if (splash) {
    splash.style.opacity = '0';
    setTimeout(() => splash.remove(), 350);
  }
});